export default class RecoverStep {


    constructor(template) {
        this.stepTemplate = template;
    }

    get template() {
        return this.stepTemplate;
    }

    open(data, el, fr, previousStep) {}

    close(data, el, fr) {}

    postRender(data, el, fr) {}

    transitionContactSupport(data, el, fr) {}

    transitionBack(data, el, fr) {}

    render(data, el, fr) {}

    transitionNext(data, el, fr) {}

    transitionCreate(data, el, fr) {}

    transitionTryAgain(data, el, fr) {}
}
